/**
 * 원본: .old-gc-mono/apps/gc-zoku/components/Logo.js
 * GGContent 로고 컴포넌트
 */
function Logo() {
  return (
    <a
      href="https://ggcontent.com"
      className="flex items-center h-full mr-8"
    >
      <img
        src="/assets/images/GC-Logo-White.svg"
        alt="GGContent"
        className="h-8"
      />
    </a>
  );
}

export default Logo;
